import React from "react";

interface HourlyPricesModalProps {
  open: boolean;
  onClose: () => void;
  hourlyPrices: Record<string, Record<string, number>>;
  dayMap: Record<string, string>;
  hours: number[]; // still accepted, but full 24h shown
}

const FULL_DAY_HOURS = Array.from({ length: 24 }, (_, i) => i);

const formatHourRange = (hour: number) => {
  const next = (hour + 1) % 24;
  return `${hour}-${next}`;
};

const HourlyPricesModal: React.FC<HourlyPricesModalProps> = ({
  open,
  onClose,
  hourlyPrices,
  dayMap,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div className="bg-white rounded-xl w-[95%] max-w-6xl p-4">
        <div className="flex justify-between mb-3">
          <h3 className="text-sm font-semibold">Hourly Prices</h3>
          <button
            onClick={onClose}
            className="text-sm text-gray-500 hover:text-black"
          >
            ✕
          </button>
        </div>

        <div className="overflow-auto max-h-[70vh]">
          <table className="border-collapse w-full text-xs">
            <thead>
              <tr>
                <th className="border p-2 bg-gray-50 sticky left-0 z-10">
                  Day / Hour
                </th>

                {FULL_DAY_HOURS.map((hour) => (
                  <th
                    key={hour}
                    className="border p-2 bg-gray-50 whitespace-nowrap"
                  >
                    {formatHourRange(hour)}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {Object.entries(dayMap).map(([dayKey, dayLabel]) => (
                <tr key={dayKey}>
                  <td className="border p-2 font-medium bg-white sticky left-0 z-10">
                    {dayLabel}
                  </td>

                  {FULL_DAY_HOURS.map((hour) => (
                    <td key={hour} className="border p-2 text-center">
                      {hourlyPrices?.[dayKey]?.[hour] ?? "—"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HourlyPricesModal;
